/**
 * assets/header-nav-pill.js
 *
 * Sizes the dark pill background (.header__nav-pill-bg) to match the
 * combined rendered width of the logo + nav, so it visually wraps just
 * those two without needing to touch the grid layout itself for
 * #logo/#main-nav/#shopping-links (which stay exactly where they were).
 * Re-measures on resize since the grid's column widths are responsive.
 *
 * Note: closing the visible gap between the logo and nav is handled in
 * CSS (right-aligning the logo within its own grid cell), not here.
 * #main-nav's .span-6.auto class sets width:100%, filling its whole
 * grid track, and that track uses a flexible 1fr unit — nudging a
 * width:100% item with a JS-measured margin-left doesn't just shift it
 * locally, it can perturb the 1fr track-sizing calculation for the
 * whole row. Moving the logo within its own already-oversized cell
 * avoids touching nav's box model at all.
 */
(function () {
  if (window.__headerNavPillLoaded) return;
  window.__headerNavPillLoaded = true;

  function sizePill(wrapper, bg, logo, nav) {
    var wrapperRect = wrapper.getBoundingClientRect();
    var navRect = nav.getBoundingClientRect();
    var logoRect = logo.getBoundingClientRect();

    var left = Math.min(logoRect.left, navRect.left) - wrapperRect.left;
    var right = Math.max(logoRect.right, navRect.right) - wrapperRect.left;

    bg.style.left = left + 'px';
    bg.style.width = (right - left) + 'px';
  }

  function update() {
    var wrapper = document.querySelector('#header-wrapper.header__main-wrapper');
    var bg = wrapper && wrapper.querySelector('.header__nav-pill-bg');
    var logo = wrapper && wrapper.querySelector('#logo.header__desktop-logo');
    var nav = wrapper && wrapper.querySelector('#main-nav.header__main-nav');
    if (!wrapper || !bg || !logo || !nav) return;

    sizePill(wrapper, bg, logo, nav);
  }

  function init() {
    update();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(update, 150);
    });

    // Fonts/logo image loading can shift widths after the first paint.
    window.addEventListener('load', update);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
